import roles from "@/utils/data/roles";

export default {
    filters: {
        formatRole(roleId) {
            if (!roles || !roleId) return "Неизвестная роль";
            const [output] = roles.filter(role => role.id === roleId);
            return output.name;
        },
    }
}